import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { SecurityApiClient } from "../api-client/api-client";
import type { TryConnectionParams, TryConnectionResponse } from "../types";

export default function useTryConnectionMutation(
  options?: UseMutationOptions<TryConnectionResponse, Error, TryConnectionParams>
) {
  return useMutation<TryConnectionResponse, Error, TryConnectionParams>({
    mutationFn: async (params: TryConnectionParams) => {
      const res = await SecurityApiClient.tryConnectViaOTP(
        params.email,
        params.password,
        params.codeOtp
      );
      return res;
    },
    ...options
  });
}
